export const ROUTE_ACCESS = {
    "/": [1, 2, 3, 4],

    "/quality-dashboard": [2, 3, 4],
    "/ehs-dashboard": [2, 3, 4],
    "/productivity-utilization": [2, 3, 4],

    "/customers": [2],
    "/asp-companies": [2, 3],
    "/asp-resources": [2, 3, 4],

    "/create-session": [2, 3],
    "/approve-session": [1, 2],

    "/sites": [2],
    "/projects": [2],
    "/workplans": [2, 4],
    "/teams": [2, 4],
    "/activities": [2, 3, 4],

    "/deletion-Requests": [2],

    "/activity-checklist-items": [2],

    "/ehs-pings": [2, 4],

    "/integration_api": [2],

    "/report-builder": [1, 2],
    "/my-reports": [1, 2],

    "/rsc-dashboard": [2],
    "/rsc-assignment": [2],

    "/customer-session-report": [1, 2],

    "/users": [2],
    "/workflows": [2],

    "/complaints": [2, 3, 4],

    "/user-manuals": [1, 2, 3, 4],

    "/my-profile": [1, 2, 3, 4]
};